/* ============================================================================
   EASTEAM quick view — behaviour
   ----------------------------------------------------------------------------
   Pairs with sections/product-quick-view.liquid (the v7 markup) and
   assets/ea-quickview.css (the popup shell).

   WHY THIS FILE EXISTS SEPARATELY
   theme.js fills the popup with `.popup-body-inner.innerHTML = section`, and
   innerHTML never executes <script>. So the section ships markup and <style>
   only, and every behaviour lives here, bound when the popup fills. A
   MutationObserver on .popup-body-inner is what notices.

   WHAT IT DRIVES
     · the photo stack — one step per gesture, eased, never pixel-dragged
     · the before/after slider, as the LAST shot of that stack, on products
       that carry the before/after metafields (same rule as the PDP)
     · colour / size / availability against the real variant list
     · "N left" under each size, and the measurements line for the chosen size
     · Make to Order, auto-selected when a size has no stock, with the real %
     · Previously On: videos roll in the strip, and any tile opens the story
       viewer, which is the PDP's viewer rebuilt here
     · accordions, add to bag, checkout

   NOTIFY ME WAS REMOVED 2026-09-24 — Scarlett is not running a back-in-stock
   feature. The markup, the Klaviyo calls and window.EA_NOTIFY are all gone.

   THE STORY VIEWER IS APPENDED TO <body>, NOT INSIDE THE POPUP.
   The popup clips its overflow, so a viewer rendered inside it would be
   cropped to the box. Its CSS is injected once, here, for the same reason.

   STOCK NUMBERS come from the section's data island, because Liquid can read
   variant.inventory_quantity and the Ajax API cannot.
   ==========================================================================*/
(function () {
  'use strict';

  var MTO = /pre.?order|made.?to.?order/i;

  function money(cents, fmt) {
    var n = (cents || 0) / 100;
    var s = /no_decimals/.test(fmt || '') ? String(Math.round(n)) : n.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* =========================================================================
     the story viewer — one per page, reused
     ======================================================================= */
  var MOV = null;
  function movStyle() {
    if (document.getElementById('eaqvmov-css')) return;
    var s = document.createElement('style');
    s.id = 'eaqvmov-css';
    s.textContent =
      '.eaqvmov{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;' +
        'background:rgba(10,8,7,.5);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px)}' +
      '.eaqvmov.open{display:flex}' +
      '.eaqvmov-card{position:relative;width:94%;max-width:440px;height:88vh;max-height:900px;' +
        'overflow:hidden;background:#000;box-shadow:0 24px 70px rgba(0,0,0,.55)}' +
      '.eaqvmov-x{position:absolute;top:16px;right:16px;z-index:6;width:40px;height:40px;border-radius:50%;' +
        'background:rgba(0,0,0,.42);color:#fff;border:1px solid rgba(255,255,255,.35);font-size:15px;' +
        'line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer}' +
      '.eaqvmov-track{position:absolute;inset:0;display:flex;overflow-x:scroll;overflow-y:hidden;' +
        'scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;' +
        'touch-action:pan-x;overscroll-behavior:contain}' +
      '.eaqvmov-track::-webkit-scrollbar{display:none}' +
      '.eaqvmov-slide{position:relative;flex:0 0 100%;width:100%;height:100%;scroll-snap-align:start;' +
        'display:flex;align-items:center;justify-content:center;background:#000}' +
      '.eaqvmov-slide img,.eaqvmov-slide video{width:100%;height:100%;object-fit:contain;display:block;background:#000}' +
      '.eaqvmov-bars{position:absolute;top:10px;left:12px;right:12px;z-index:6;display:flex;gap:4px}' +
      '.eaqvmov-bar{flex:1;height:2.5px;border-radius:2px;background:rgba(255,255,255,.32);overflow:hidden}' +
      '.eaqvmov-bar i{display:block;height:100%;width:0;background:#fff;transition:width .12s linear}' +
      '.eaqvmov-bar.on i{width:100%}' +
      '.eaqvmov-cap{position:absolute;left:0;right:0;bottom:0;z-index:5;padding:40px 16px 16px;' +
        'background:linear-gradient(to top,rgba(10,8,7,.66),rgba(10,8,7,0));color:#fff}' +
      '.eaqvmov-nm{font-family:"Roboto Mono",monospace;font-size:12px;letter-spacing:.1em;text-transform:uppercase}' +
      '.eaqvmov-pr{font-family:"Roboto Mono",monospace;font-size:12px;letter-spacing:.04em;color:#C49099;margin-top:4px}' +
      '.eaqvmov-shop{display:inline-block;margin-top:12px;background:#F5F0EC;color:#0A0807;' +
        'font-family:"Jost",sans-serif;font-weight:500;font-size:12px;letter-spacing:.14em;' +
        'text-transform:uppercase;padding:11px 18px;text-decoration:none}';
    document.head.appendChild(s);
  }
  function movBuild() {
    if (MOV) return MOV;
    movStyle();
    var el = document.createElement('div');
    el.className = 'eaqvmov';
    el.innerHTML =
      '<div class="eaqvmov-card">' +
        '<button type="button" class="eaqvmov-x" aria-label="Close">✕</button>' +
        '<div class="eaqvmov-bars"></div>' +
        '<div class="eaqvmov-track"></div>' +
      '</div>';
    document.body.appendChild(el);
    var track = el.querySelector('.eaqvmov-track');
    el.querySelector('.eaqvmov-x').addEventListener('click', movClose);
    el.addEventListener('click', function (e) { if (e.target === el) movClose(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('open')) movClose();
    });
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(movSync, 80);
    });
    MOV = el;
    return el;
  }
  function movSync() {
    if (!MOV) return;
    var track = MOV.querySelector('.eaqvmov-track');
    var i = Math.round(track.scrollLeft / track.clientWidth);
    MOV.querySelectorAll('.eaqvmov-bar').forEach(function (b, n) { b.classList.toggle('on', n <= i); });
    MOV.querySelectorAll('video').forEach(function (v, n) {
      if (n === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else { try { v.pause(); } catch (e) {} }
    });
  }
  function movOpen(looks, index) {
    var el = movBuild();
    var track = el.querySelector('.eaqvmov-track');
    var bars = el.querySelector('.eaqvmov-bars');
    track.innerHTML = looks.map(function (L) {
      var media = L.video
        ? '<video src="' + L.src + '" poster="' + (L.poster || '') + '" muted loop playsinline preload="metadata"></video>'
        : '<img src="' + L.src + '" alt="">';
      return '<div class="eaqvmov-slide">' + media +
        '<div class="eaqvmov-cap">' +
          '<div class="eaqvmov-nm">' + (L.name || '') + '</div>' +
          '<div class="eaqvmov-pr">' + (L.price || '') + '</div>' +
          (L.url ? '<a class="eaqvmov-shop" href="' + L.url + '">Shop this look</a>' : '') +
        '</div></div>';
    }).join('');
    bars.innerHTML = looks.map(function () { return '<span class="eaqvmov-bar"><i></i></span>'; }).join('');
    el.classList.add('open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      track.scrollLeft = track.clientWidth * (index || 0);
      movSync();
    });
  }
  function movClose() {
    if (!MOV) return;
    MOV.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    MOV.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* =========================================================================
     before / after — the quick-view copy of assets/ea-ba-slider.js
     ---------------------------------------------------------------------
     The section renders an empty <div class="ea-ba" data-eaqv-ba> with the
     two image URLs as data attributes, inside the last .shot of the stack,
     and links assets/ea-ba-slider.css. This builds the same DOM the PDP
     slider builds, so that one stylesheet styles both. Keep the class names
     in lockstep with ea-ba-slider.js.
     Pointer events stop at the slider, so dragging the wipe never reaches
     the stack. The wheel is left alone on purpose: scrolling still steps
     back up through the photos.
     ======================================================================= */
  function baBuild(box) {
    if (!box || box.__eaBa) return;
    box.__eaBa = true;
    var before = box.getAttribute('data-before'), after = box.getAttribute('data-after');
    if (!before || !after) return;
    var title = box.getAttribute('data-title') || 'this piece';

    function el(tag, cls, html) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (html != null) n.innerHTML = html;
      return n;
    }
    box.setAttribute('tabindex', '0');
    box.setAttribute('role', 'slider');
    box.setAttribute('aria-label', 'Before and after: ' + title);
    box.setAttribute('aria-valuemin', '0');
    box.setAttribute('aria-valuemax', '100');

    var aImg = el('img'); aImg.src = after; aImg.alt = title + ' worn'; aImg.draggable = false;
    var bWrap = el('div', 'ea-ba-before');
    var bImg = el('img'); bImg.src = before; bImg.alt = 'Without the piece'; bImg.draggable = false;
    bWrap.appendChild(bImg);
    var line = el('div', 'ea-ba-line');
    line.appendChild(el('div', 'ea-ba-knob',
      '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" focusable="false">' +
      '<path d="M9 5v14M15 5v14" stroke="#0A0807" stroke-width="2" stroke-linecap="round" fill="none"/></svg>'));
    box.appendChild(aImg);
    box.appendChild(bWrap);
    box.appendChild(el('span', 'ea-ba-tag ea-ba-tag-b', 'Before'));
    box.appendChild(el('span', 'ea-ba-tag ea-ba-tag-a', 'After'));
    box.appendChild(line);
    box.appendChild(el('div', 'ea-ba-hint', 'Drag to reveal'));

    var dragging = false;
    function set(p) {
      p = Math.max(0, Math.min(100, p));
      bWrap.style.width = p + '%';
      line.style.left = p + '%';
      bImg.style.width = (p > 0.5 ? (10000 / p) : 20000) + '%';
      box.setAttribute('aria-valuenow', String(Math.round(p)));
    }
    function fromEvent(e) {
      var r = box.getBoundingClientRect();
      if (!r.width) return;
      set(((e.clientX - r.left) / r.width) * 100);
    }
    box.addEventListener('pointerdown', function (e) {
      dragging = true;
      box.classList.add('is-touched');
      try { box.setPointerCapture(e.pointerId); } catch (err) {}
      fromEvent(e);
      e.preventDefault();
      e.stopPropagation();
    });
    box.addEventListener('pointermove', function (e) { if (dragging) { fromEvent(e); e.preventDefault(); e.stopPropagation(); } });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      box.addEventListener(t, function () { dragging = false; });
    });
    // a horizontal drag on a phone must not also count as a vertical stack swipe
    box.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
    box.addEventListener('touchmove', function (e) { e.stopPropagation(); }, { passive: true });
    box.addEventListener('click', function (e) { e.stopPropagation(); });
    box.addEventListener('keydown', function (e) {
      var cur = parseFloat(box.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') { set(cur - 4); box.classList.add('is-touched'); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(cur + 4); box.classList.add('is-touched'); e.preventDefault(); }
    });
    set(50);
  }

  /* =========================================================================
     one quick view
     ======================================================================= */
  function init(root) {
    if (root.__eaqv) return;
    root.__eaqv = true;

    var D, LOOKS = [];
    try { D = JSON.parse(root.querySelector('[data-eaqv-data]').textContent); }
    catch (e) { return; }
    try { LOOKS = JSON.parse(root.querySelector('[data-eaqv-looks]').textContent) || []; }
    catch (e) { LOOKS = []; }

    var SI = D.sizeIndex, CI = D.colorIndex, AI = D.availIndex;
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var start = D.variants.filter(function (v) { return v.id === D.selected; })[0] || D.variants[0];
    var chosen = (start.options || []).slice();

    function matches(v, probe) {
      for (var i = 0; i < probe.length; i++) {
        if (probe[i] == null) continue;
        if (String(v.options[i]) !== String(probe[i])) return false;
      }
      return true;
    }
    function find(probe) {
      for (var i = 0; i < D.variants.length; i++) if (matches(D.variants[i], probe)) return D.variants[i];
      return null;
    }
    function current() { return find(chosen); }
    function sellable(v) {
      if (!v) return false;
      if (v.available) return true;
      return v.managed == null || v.policy === 'continue';
    }
    function mtoTwin(size) {
      if (AI < 0) return null;
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i];
        if (!MTO.test(v.options[AI] || '')) continue;
        if (SI >= 0 && size != null && String(v.options[SI]) !== String(size)) continue;
        if (CI >= 0 && chosen[CI] != null && String(v.options[CI]) !== String(chosen[CI])) continue;
        if (sellable(v)) return v;
      }
      return null;
    }
    function stockFor(size) {
      var probe = chosen.slice();
      if (SI >= 0) probe[SI] = size;
      if (AI >= 0) probe[AI] = null;
      var best = null;
      D.variants.forEach(function (v) {
        if (!matches(v, probe)) return;
        if (AI >= 0 && MTO.test(v.options[AI] || '')) return;
        if (best === null || v.qty > best) best = v.qty;
      });
      return best;
    }

    var ROWS = [];
    try { ROWS = typeof D.rows === 'string' ? JSON.parse(D.rows) : (D.rows || []); } catch (e) { ROWS = []; }
    if (!ROWS) ROWS = [];
    function rowFor(size) {
      for (var i = 0; i < ROWS.length; i++) {
        if (String(ROWS[i][0]).toUpperCase() === String(size).toUpperCase()) return ROWS[i];
      }
      return null;
    }
    /* row shape: [size, bust", waist", hip", length", bustcm, waistcm, hipcm] */
    function measure(size) {
      var r = rowFor(size);
      if (!r) return '';
      var bits = [];
      if (r[1]) bits.push('bust ' + r[1] + '"');
      if (r[2]) bits.push('waist ' + r[2] + '"');
      if (r[3]) bits.push('hip ' + r[3] + '"');
      return bits.join(' · ');
    }

    (function chart() {
      var host = q('[data-eaqv-chart]');
      if (!host) return;
      if (!ROWS.length) { var acc = host.closest('.acc'); if (acc) acc.hidden = true; return; }
      host.querySelector('tbody').innerHTML = ROWS.map(function (r) {
        return '<tr data-size="' + r[0] + '"><td>' + r[0] + '</td><td>' + (r[1] || '—') +
               '"</td><td>' + (r[2] || '—') + '"</td><td>' + (r[3] || '—') + '"</td></tr>';
      }).join('');
    })();

    function paint() {
      var v = current();
      var fmt = D.moneyFormat;

      var price = v ? v.price : start.price;
      var base = null;
      if (AI >= 0 && v && MTO.test(v.options[AI] || '')) {
        var probe = chosen.slice(); probe[AI] = null;
        D.variants.forEach(function (x) {
          if (!matches(x, probe)) return;
          if (MTO.test(x.options[AI] || '')) return;
          if (base === null || x.price > base) base = x.price;
        });
      }
      q('[data-eaqv-now]').textContent = money(price, fmt);
      var was = q('[data-eaqv-was]');
      if (base && base > price) { was.textContent = money(base, fmt); was.hidden = false; }
      else was.hidden = true;
      var cta = q('[data-eaqv-cta]'); if (cta) cta.textContent = money(price, fmt);
      var inst = q('[data-eaqv-inst]');
      if (inst) inst.innerHTML = price >= 3500
        ? 'Pay in 4 interest-free payments of <b>' + money(Math.round(price / 4), fmt) + '</b>'
        : '';

      if (CI >= 0) {
        qa('[data-eaqv-pick="color"]').forEach(function (b) {
          b.classList.toggle('sel', b.dataset.value === chosen[CI]);
        });
        var nm = q('[data-eaqv-swname]'); if (nm) nm.textContent = chosen[CI] || '';
        var sub = q('[data-eaqv-sub]'); if (sub) sub.textContent = chosen[CI] || '';
      }

      if (SI >= 0) {
        qa('[data-eaqv-pick="size"]').forEach(function (b) {
          var size = b.dataset.value;
          var left = stockFor(size);
          var twin = mtoTwin(size);
          var el = b.querySelector('[data-eaqv-qty]');
          if (el) el.textContent = (left && left > 0) ? left + ' left' : '';
          b.classList.toggle('sel', size === chosen[SI]);
          b.classList.toggle('gone', !(left > 0) && !twin);
        });
      }

      if (AI >= 0) {
        var leftNow = SI >= 0 ? stockFor(chosen[SI]) : null;
        if (!(leftNow > 0)) {
          var tw = mtoTwin(SI >= 0 ? chosen[SI] : null);
          if (tw) chosen[AI] = tw.options[AI];
        }
        qa('[data-eaqv-pick="avail"]').forEach(function (b) {
          var val = b.dataset.value;
          var p3 = chosen.slice(); p3[AI] = val;
          var pv = find(p3);
          b.classList.toggle('sel', val === chosen[AI]);
          b.classList.toggle('off', !sellable(pv));
          var off = b.querySelector('[data-eaqv-off]');
          if (off) {
            off.textContent = '';
            if (MTO.test(val) && pv) {
              var p2 = chosen.slice(); p2[AI] = null;
              var full = null;
              D.variants.forEach(function (x) {
                if (!matches(x, p2)) return;
                if (MTO.test(x.options[AI] || '')) return;
                if (full === null || x.price > full) full = x.price;
              });
              if (full && full > pv.price) off.textContent = '−' + Math.round((1 - pv.price / full) * 100) + '%';
            }
          }
        });
        var note = q('[data-eaqv-avnote]');
        if (note) note.textContent = MTO.test(chosen[AI] || '') ? 'Ships within 6 weeks' : 'Ships within 3 days';
      }

      var bar = q('[data-eaqv-sizebar]');
      if (bar && SI >= 0) {
        var size2 = chosen[SI];
        var m = measure(size2);
        var left2 = stockFor(size2);
        var bits = ['<b>Size ' + size2 + '</b>'];
        if (m) bits.push(m);
        if (left2 > 0) bits.push(left2 + ' left');
        bar.innerHTML = bits.join(' · ');
      }

      qa('[data-eaqv-chart] tbody tr').forEach(function (tr) {
        tr.classList.toggle('me', SI >= 0 && tr.dataset.size === chosen[SI]);
      });

      var ok = sellable(current());
      var main2 = q('[data-eaqv-checkout]'), sec2 = q('[data-eaqv-atc]');
      if (main2) { main2.disabled = !ok; main2.style.opacity = ok ? '1' : '.4'; }
      if (sec2) { sec2.disabled = !ok; sec2.style.opacity = ok ? '1' : '.4'; }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-eaqv-pick]');
      if (!b || b.classList.contains('off')) return;
      var kind = b.dataset.eaqvPick;
      var idx = kind === 'size' ? SI : kind === 'color' ? CI : AI;
      if (idx < 0) return;
      chosen[idx] = b.dataset.value;
      if (kind === 'size' && AI >= 0 && stockFor(b.dataset.value) > 0) {
        var inStock = D.variants.filter(function (v) { return !MTO.test(v.options[AI] || ''); })[0];
        if (inStock) chosen[AI] = inStock.options[AI];
      }
      paint();
    });

    root.addEventListener('click', function (e) {
      var h = e.target.closest('.acc > .head');
      if (!h) return;
      var acc = h.parentElement, open = acc.classList.contains('closed');
      acc.classList.toggle('closed', !open);
      acc.classList.toggle('open', open);
      var tg = h.querySelector('.tg'); if (tg) tg.textContent = open ? '−' : '+';
    });

    /* the before/after shot, if this product has one — built before the
       stack counts its shots, so it is simply the last step */
    qa('[data-eaqv-ba]').forEach(baBuild);

    /* ----- the photo stack -------------------------------------------------
       ONE STEP PER GESTURE, not a pixel-by-pixel drag. The easing lives on
       .shot in the section's CSS; this only decides when to step. Accumulating
       raw wheel deltas is what made the first version feel jerky: a trackpad
       fires dozens of tiny deltas and the stack crawled through them.        */
    (function gallery() {
      var shots = qa('.imgpin .shot');
      var dots = qa('[data-eaqv-dots] i');
      var frame = q('[data-eaqv-frame]');
      var scroller = q('.eaqv-scroll');
      if (shots.length < 2) return;
      var last = shots.length - 1;
      var at = 0, lock = false, buf = 0;

      shots.forEach(function (s, n) { s.style.zIndex = String(n + 1); });
      function apply() {
        shots.forEach(function (el, n) {
          el.style.transform = n === 0 ? 'none' : 'translate3d(0,' + (n <= at ? 0 : 100) + '%,0)';
        });
        dots.forEach(function (d, n) { d.classList.toggle('on', n === at); });
      }
      function step(dir) {
        var next = Math.max(0, Math.min(last, at + dir));
        if (next === at) return false;
        at = next; apply();
        lock = true;
        setTimeout(function () { lock = false; }, 420);
        return true;
      }
      function gesture(dy, gate) {
        if (gate && gate.scrollTop > 0) return false;
        if (lock) return true;
        buf += dy;
        if (Math.abs(buf) < 45) return (dy > 0 ? at < last : at > 0);
        var moved = step(buf > 0 ? 1 : -1);
        buf = 0;
        return moved;
      }
      function bind(target, gate) {
        if (!target) return;
        target.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
          if (gesture(e.deltaY, gate)) e.preventDefault();
        }, { passive: false });
        var ty = null, moved = false;
        target.addEventListener('touchstart', function (e) { ty = e.touches[0].clientY; moved = false; buf = 0; }, { passive: true });
        target.addEventListener('touchmove', function (e) {
          if (ty === null) return;
          var dy = ty - e.touches[0].clientY;
          if (Math.abs(dy) < 40 || moved) { if (moved && e.cancelable) e.preventDefault(); return; }
          if (gesture(dy, gate)) { moved = true; if (e.cancelable) e.preventDefault(); }
        }, { passive: false });
        target.addEventListener('touchend', function () { ty = null; buf = 0; }, { passive: true });
      }
      if (window.matchMedia('(max-width:767px)').matches) bind(scroller, scroller);
      else bind(frame, null);
      dots.forEach(function (d, n) {
        d.addEventListener('click', function (e) { e.stopPropagation(); at = n; apply(); });
      });
      apply();
    })();

    /* ----- Previously On: roll the videos, drag the strip, open the viewer -- */
    (function strip() {
      var s = q('[data-eaqv-ugc]');
      if (!s) return;

      // muted autoplay is allowed without a gesture, but Safari still wants the
      // explicit call, and a rejected promise must not bubble
      s.querySelectorAll('video').forEach(function (v) {
        v.muted = true; v.playsInline = true;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      });

      var down = false, x0 = 0, l0 = 0, dragged = false;
      s.addEventListener('mousedown', function (e) {
        down = true; dragged = false; s.classList.add('drag');
        x0 = e.pageX; l0 = s.scrollLeft; e.preventDefault();
      });
      window.addEventListener('mouseup', function () { down = false; s.classList.remove('drag'); });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        if (Math.abs(e.pageX - x0) > 4) dragged = true;
        s.scrollLeft = l0 - (e.pageX - x0);
      });
      s.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-eaqv-look]');
        if (!tile || dragged) return;          // a drag is not a click
        // media comes off the tiles themselves — see assets/ea-quickview-looks.js
        var looks = window.EAQuickViewLooks ? window.EAQuickViewLooks(s, LOOKS) : LOOKS;
        if (!looks || !looks.length) return;
        movOpen(looks, parseInt(tile.dataset.eaqvLook, 10) || 0);
      });
    })();

    /* ----- buying ---------------------------------------------------------- */
    function add(then) {
      var v = current();
      if (!v) return;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(then)
        .catch(function () { location.href = D.url + '?variant=' + v.id; });
    }
    var secBtn = q('[data-eaqv-atc]');
    if (secBtn) secBtn.addEventListener('click', function () {
      add(function () {
        var o = secBtn.textContent;
        secBtn.classList.add('added'); secBtn.textContent = 'In your bag ✓';
        setTimeout(function () { secBtn.classList.remove('added'); secBtn.textContent = o; }, 1600);
      });
    });
    var mainBtn = q('[data-eaqv-checkout]');
    if (mainBtn) mainBtn.addEventListener('click', function () {
      add(function () { location.href = '/checkout'; });
    });

    paint();
  }

  function scan(node) { (node || document).querySelectorAll('[data-eaqv]').forEach(init); }
  var watching = false;
  function watch() {
    if (watching) return true;
    var host = document.querySelector('.quickview-popup .popup-body-inner');
    if (!host) return false;
    watching = true;
    new MutationObserver(function () { scan(host); }).observe(host, { childList: true, subtree: true });
    scan(host);
    return true;
  }
  if (!watch()) {
    var tries = 0;
    var t = setInterval(function () { if (watch() || ++tries > 40) clearInterval(t); }, 250);
  }
  document.addEventListener('DOMContentLoaded', function () { watch(); });
})();
